import React from "react";

import { templates } from "@reactivated";

import { SessionKeepAlive } from "../apps/customer-account/SessionKeepAlive";

export const Template = (
    _props: templates.SessionKeepAliveTemplate,
): React.JSX.Element => {
    return <SessionKeepAlive />;
};
